document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.technical-tabs__tab');
  const tabPanels = document.querySelectorAll('.technical-tabs__panel');
  
  // Only run if technical tabs exist on the page
  if (tabButtons.length === 0) return;
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // Remove active class from all buttons and panels
      tabButtons.forEach(btn => btn.classList.remove('technical-tabs__tab--active'));
      tabPanels.forEach(panel => panel.classList.remove('technical-tabs__panel--active'));
      
      // Add active class to clicked button and corresponding panel
      this.classList.add('technical-tabs__tab--active');
      const targetPanel = document.getElementById(targetTab);
      if (targetPanel) {
        targetPanel.classList.add('technical-tabs__panel--active');
      }
    });
  });
});